import { render, staticRenderFns } from "./LogTableElementPagination.vue?vue&type=template&id=4020a2ad&"
import script from "./LogTableElementPagination.vue?vue&type=script&lang=js&"
export * from "./LogTableElementPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports